import React, {Component} from 'react';
import axios from "axios";
import Select from "react-select";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

import './SuggestedExercisesInput.css';
import apiUrl from "../../../shared/config";
import DeleteButton from "../ExampleGamesInput/ExampleGameInputButtons/DeleteButton";
import {styleRedShadow, selectRedShadow} from "../../../utils/commonStyles";
import {validStringField} from "../../../utils/utils";

class SuggestedExercisesInput extends Component  {
    state = {
        exercises: [],
        suggested_exercises: [],
        hoveredRemoveIconIndex: null,
    };

    componentDidMount() {
        if (this.state.exercises !== []) {
            axios.get(apiUrl +'Exercises/getExercises')
                .then(response => {
                    this.setState({exercises: response.data.exercises_array});
                });
        }
        this.setState({suggested_exercises: this.props.suggestedExercises});
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps !== this.props) {
            this.setState({suggested_exercises: this.props.suggestedExercises});
        }
    }

    addSuggestedExercise = () => {
        const new_value = [...this.state.suggested_exercises,
            {
                pattern_id: null,
                exercise_id: null,
                suggested_exercise_description: ""
            }]
        this.props.suggestedExercisesUpdate(new_value);
        this.setState(
            {suggested_exercises: new_value});
    };

    arraySearch(arr,val) {
        for (let i = 0; i < arr.length; i++) {
            if (arr[i].value === val)
                return i;
        }
        return -1;
    }

    render() {
        let suggestedExercisesInputElement = null;
        if (this.state.exercises && this.state.exercises.length) {
            const exerciseOptions = this.state.exercises
                .map( exercise => ({value: exercise.exercise_id, label: exercise.exercise_name}));

            if (this.state.suggested_exercises && this.state.suggested_exercises.length) {
                let suggested_exercise_array_index = 0;
                let suggested_exercises = [...this.state.suggested_exercises];
                suggestedExercisesInputElement = (
                    <>
                        <dd className="col-sm-9">
                            {suggested_exercises.map(exercise => {

                                let suggested_exercise_index_local = suggested_exercise_array_index;
                                const suggested_exercise_id = suggested_exercises[suggested_exercise_array_index].exercise_id;
                                const default_index = this.arraySearch(exerciseOptions, suggested_exercise_id);
                                let default_value = {label: "Select a exercise to suggest."};
                                if (suggested_exercise_id !== null) {
                                    default_value = exerciseOptions[default_index];
                                }


                                const return_jsx = (
                                    <div className="suggested-exercises-block" key={suggested_exercise_id + "  " + suggested_exercise_index_local}>
                                        <Select
                                            styles={selectRedShadow(suggested_exercises[suggested_exercise_index_local].exercise_id)}
                                            className="example-games-select-semi-full"
                                            defaultValue={{
                                                value: suggested_exercises[suggested_exercise_index_local].exercise_id,
                                                label: default_value.label,
                                                isFixed: true,
                                                isDisabled: true
                                            }}
                                            options={exerciseOptions}
                                            closeMenuOnSelect={true}
                                            onChange={(val) => {
                                                // let suggested_exercises_local = [...suggested_exercises];
                                                suggested_exercises[suggested_exercise_index_local] = {
                                                    exercise_id: val.value,
                                                    suggested_exercise_description: suggested_exercises[suggested_exercise_index_local].suggested_exercise_description
                                                };
                                                this.setState({suggested_exercises: suggested_exercises});
                                                this.props.suggestedExercisesUpdate(suggested_exercises);
                                            }}
                                        />
                                        <div key={suggested_exercise_id+"_delete"} style={{display: "flex", height: "35px",}}>
                                            <DeleteButton onDelete={() => {
                                                let filtered_array = suggested_exercises.filter((value,index,array) => {
                                                    return index !== (suggested_exercise_index_local)
                                                });
                                                this.setState({suggested_exercises: filtered_array});
                                                this.props.suggestedExercisesUpdate(filtered_array);
                                            }} />
                                        </div>
                                        <div className="suggested-exercises-description">
                                            <Form.Control
                                                style={styleRedShadow(validStringField(exercise.suggested_exercise_description))}
                                                as="textarea"
                                                rows="2"
                                                placeholder="How should this exercise be used to create a related pattern?"
                                                value={exercise.suggested_exercise_description}
                                                onChange={(event) => {
                                                    let suggested_exercises_local = [...suggested_exercises];
                                                    suggested_exercises_local[suggested_exercise_index_local] = {
                                                        exercise_id: suggested_exercises_local[suggested_exercise_index_local].exercise_id,
                                                        suggested_exercise_description: event.target.value
                                                    };
                                                    this.setState({suggested_exercises: suggested_exercises_local});
                                                    this.props.suggestedExercisesUpdate(suggested_exercises_local);
                                                }}/>
                                        </div>
                                    </div>
                                );
                                suggested_exercise_array_index++;

                                return return_jsx;
                            })}
                        </dd>
                        <dt className="col-sm-3"> </dt>
                    </>
                );


            }
        }

        return (
            <dl className="row">
                <dt className="col-sm-3"><label>Suggested Exercises</label></dt>
                {suggestedExercisesInputElement}
                <dd className="col-sm-9"><Button className="col-sm-12" variant="outline-primary" onClick={this.addSuggestedExercise}>Add Suggested Exercise</Button></dd>
            </dl>
        );
    }
}

export default SuggestedExercisesInput;